import { nameOf } from "../../Utils/nameOf";
import { SupplierFormTabs } from "./SupplierFormTabs";
import { useAddSupplier } from "../Hooks/useAddSupplier";
import Supplier from "../Supplier";
import { supplierDefaultValues } from "./supplierDefaultValues";

export const AddSupplier = () => {
  const { mutate: addSupplier } = useAddSupplier();

  const disabledFields: Array<string> = [
    nameOf<Supplier>("MGLongitude"),
    nameOf<Supplier>("MGLatitude"),
    nameOf<Supplier>("AltMGLatitude"),
    nameOf<Supplier>("AltMGLongitude"),
  ];

  return (
    <SupplierFormTabs
      title="Add Supplier"
      supplier={supplierDefaultValues}
      onSave={(supplier: Supplier) => addSupplier(supplier)}
      disabledField={disabledFields}
    />
  );
};
